import { onBeforeUnmount, onMounted, ref } from 'vue'

export function useDetailLayoutResizeObservers() {
  const navbarElement = ref(null)
  const layoutStyle = ref({
    container: {
      paddingTop: '4.6rem',
    },
  })

  let resizeObserver = null
  let timeout = null

  const setupResizeObserver = () => {
    resizeObserver = new ResizeObserver(entries => {
      for (const entry of entries) {
        if (entry.target === navbarElement.value) {
          const navHeight = entry.contentRect.height
          layoutStyle.value = {
            container: {
              paddingTop: `${navHeight - 48}px`,
            },
          }
        }
      }
    })

    timeout = setTimeout(() => {
      navbarElement.value = document.querySelector('nav')
      if (navbarElement.value) {
        resizeObserver.observe(navbarElement.value)
      }
    }, 100)
  }

  const cleanup = () => {
    if (resizeObserver && navbarElement.value) {
      resizeObserver.unobserve(navbarElement.value)
      resizeObserver = null
    }
    clearTimeout(timeout)
  }

  onMounted(() => {
    setupResizeObserver()
  })

  onBeforeUnmount(() => {
    cleanup()
  })

  return {
    navbarElement,
    layoutStyle,
    setupResizeObserver,
    cleanup,
  }
}
